export default "__VITE_ASSET__BQY3WdCx__"